export default "__VITE_ASSET__BMCAk9VA__"